import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

import { Button } from '../..';
import { PlayIcon, PauseIcon, TimesIcon } from '../../icon/solid';
import { StudioControlStyles } from '../styles';
import {
  setSetupAndTogglePrompter,
} from '../../../store/modules/studio/actions';
import {
  selectCurrentCountdown,
  selectIsCountdown,
  selectIsPlayPrompter, selectStudioMode, selectTeleprompterSync,
} from '../../../store/modules/studio/selectors';
import StudioToolTip from './StudioToolTip';
import { StudioMode } from '../../../configs/studio';


const PlayPrompterAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const isPlay = useSelector(selectIsPlayPrompter);
  const isCountdown = useSelector(selectIsCountdown);
  const currentCountdown = useSelector(selectCurrentCountdown);
  const isTeleprompterSync = useSelector(selectTeleprompterSync);
  const studioMode = useSelector(selectStudioMode);
  const isCameraMode = useMemo(() => studioMode === StudioMode.CAMERA, [studioMode]);


  const onAutoScrollPrompter = useCallback(() => {
    dispatch(setSetupAndTogglePrompter());
  }, [dispatch]);

  return (
    <Grid item>
      <Grid container direction="row">
        {isCountdown && (
          <div className={clsx(classes.countdownDelayLabel)}>{currentCountdown}</div>
        )}
        <StudioToolTip title={`Play or pause scrolling${isTeleprompterSync && isCameraMode? '. Disabled when Teleprompter and Camera are synced':''}`}>
          <div>
            <Button
              tabIndex={-1}
              className={clsx(
                classes.button,
                classes.playButton,
              )}
              onClick={onAutoScrollPrompter}
              data-intercom-target="Button: Play/Pause"
              disabled={isTeleprompterSync && isCameraMode}
            >
              {(isCountdown || (isTeleprompterSync && isCameraMode)) && <TimesIcon className={clsx(classes.icon, classes.autoScrollIcon)} />}
              {isPlay && (!isCountdown && !(isTeleprompterSync && isCameraMode)) && <PauseIcon className={clsx(classes.icon, classes.autoScrollIcon)} />}
              {!isPlay && (!isCountdown && !(isTeleprompterSync && isCameraMode)) && <PlayIcon className={clsx(classes.icon, classes.autoScrollIcon)} />}
            </Button>
          </div>
        </StudioToolTip>
      </Grid>
    </Grid>
  );
};

export default PlayPrompterAction;
